import { LogCannon } from '@ace-clublabs/log-cannon';
import { AxiosRequestConfig } from 'axios';
import uuid4 from 'uuid4';
import CookieHelper from '../utils/cookieHelper';
import { AUTH_STORAGE_LABEL } from '../utils/constants';
import { Cookies } from 'react-cookie';

export const createAxiosConfig = (endpoint: string, excludeAuth: boolean = false): AxiosRequestConfig => {
  const axiosRequestHeaders = {
    'X-Request-Id': uuid4(),
    'X-Ace-Session-Id': LogCannon.getSessionId(),
  } as { [key: string]: string };

  const cookie = new Cookies();
  const authToken = cookie.get(AUTH_STORAGE_LABEL);

  if (authToken && !excludeAuth) axiosRequestHeaders['Authorization'] = `Bearer ${authToken}`;

  const isProd = endpoint.search('api.ace.aaa.com') > -1;
  const scenario = CookieHelper.getCookie('scenario');

  if (!isProd && scenario) {
    axiosRequestHeaders['X-Ace-Mock'] = 'true';
    axiosRequestHeaders['X-Ace-Test-Scenario'] = scenario;
  }

  return {
    headers: {
      ...axiosRequestHeaders,
    },
  };
};
